import React from 'react';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import RewardsStatus from 'components/Dashboard/Rewards/RewardsStatus';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './RewardsSection.module.scss';

const RewardsSection = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.section}>
      <OpText variant="title-large-bold" className={styles.title}>
        {t('txt_your_store_credits')}
      </OpText>
      <div className={cn(styles.sectionContent, styles.rewards)}>
        <OpText variant="title-small-regular">{t('txt_store_credits_visible')}</OpText>
        <RewardsStatus />
      </div>
    </section>
  );
};

export default RewardsSection;
